import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { GeneralService } from '../../../shared/services/general.service';
import { mifielStartData } from '../../../shared/models/static-model/mifiel.model';
import { ReaderPdfComponent } from '../../../shared/inputs/reader-pdf/reader-pdf.component';
import { InputGeneralSelectComponent } from '../../../shared/inputs/input-general-select/input-general-select.component';
import { TableGeneralSimpleComponent } from '../../../shared/components-generals/table-general-simple/table-general-simple.component';
import { LoadGeneralComponent } from '../../../shared/components-generals/load-general/load-general.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  imports: [
    InputGeneralSelectComponent,
    TableGeneralSimpleComponent,
    LoadGeneralComponent,
    TranslateModule,
    MatButtonModule,
  ],
})
export class ContractsComponent {
  @Input() quotationId = 0;
  public mifielStartData: mifielStartData | null = null;
  public dataSource = new MatTableDataSource<any>([]);
  public headers: { value: string; description: string }[] = [];
  public representantes = new FormControl(null, [Validators.required]);
  public loadService = false;

  constructor(
    private staticPageService: StaticPageService,
    private generalService: GeneralService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getMiFielInitialData();
  }

  public getMiFielInitialData(): void {
    this.staticPageService
      .getMiFielInitialData({
        MifielIds: 3,
        QuotationId: this.quotationId,
      })
      .subscribe((res) => {
        if (res) this.mifielStartData = res;
      });
  }

  public openQuotationPDFDialog(): void {
    const dialogRef = this.dialog.open(ReaderPdfComponent, {
      width: '80vw', // 95% del ancho de la pantalla
      height: '70vh', // 95% del alto de la pantalla
      maxWidth: '80vw',
      maxHeight: '70vh',
      data: {
        quotationId: this.quotationId,
        ulrPDF: 'FielDocument',
      },
    });
  }

  public checkStatusMifiel(): void {
    this.staticPageService
      .checkStatusMifiel({
        idContract: this.mifielStartData?.documentos[0].mifieL_CONTRACT_ID ?? '',
      })
      .subscribe((ress) => {
        if (ress) {
          const json = JSON.parse(ress.data);

          this.dataSource.data = json.Signers.map((doc: any) => {
            return {
              Nombre: doc.Name,
              Email: doc.Email,
              Status: doc.Signed ? 'Firmado' : 'Pendiente',
              RFC: doc.TIN,
            };
          });

          this.headers = Object.keys(this.dataSource.data[0]).map((key) => ({
            value: key,
            description: key,
          }));
        }
      });
  }

  public signContract(): void {
    this.loadService = true;
    const body: {
      QuotationId: number | string;
      DocumentName: number | string;
      IdSigners: number | string;
      IdRepresentante: number | string;
      MifielId: number | string;
    } = {
      QuotationId: this.quotationId,
      DocumentName: this.mifielStartData?.documentos[0].descripcion ?? '',
      IdSigners: this.representantes.value ?? '',
      IdRepresentante: this.representantes.value ?? '',
      MifielId: 3,
    };
    this.staticPageService.signContract(body).subscribe((ress) => {
      if (ress.hasErrors == false) {
        this.generalService.viewSnacAlert(
          'Contrato Enviado',
          'normal',
          'Contrato ha sido enviado a los representantes',
        );
        this.getMiFielInitialData();
        this.mifielStartData = null;
        this.dataSource = new MatTableDataSource<any>([]);
        this.headers = [];
        this.loadService = false;
      }
    });
  }

  public cancelContract(): void {
    this.loadService = true;
    this.staticPageService
      .cancelContract({
        mifielQuotationId: this.mifielStartData?.documentos[0].iD_MIFIEL_COTIZACION ?? 0,
      })
      .subscribe((ress) => {
        if (ress.hasErrors == false) {
          this.generalService.viewSnacAlert(
            'Contrato Cancelado',
            'normal',
            'Contrato ha sido cancelado',
          );
          this.getMiFielInitialData();
          this.mifielStartData = null;
          this.dataSource = new MatTableDataSource<any>([]);
          this.headers = [];
          this.loadService = false;
        } else {
          this.loadService = false;
          this.generalService.viewSnacAlert(
            'Error al cancelar el contrato',
            'error',
            ress.errors.join(', '),
          );
          this.getMiFielInitialData();
          this.mifielStartData = null;
          this.dataSource = new MatTableDataSource<any>([]);
          this.headers = [];
        }
      });
  }
}
